<template>
  <!-- 底部 -->
  <div class="bot">
    <!-- 头部 -->
    <div class="head_info">
      <div class="head_info_logo">
        <img src="https://hfy-img.xzyunchuang.com/b52876744553c52f44397a8ed8676ad4" />
        <div>
          <p>{{ systemTime }} <span>星期{{ week }}</span></p>
          <p>
            <a href="https://szb.cnxz.com.cn/xzrb/pc/layout/index.html" target="_blank">徐州日报</a>
            <a href="https://szb.cnxz.com.cn/dscb/pc/layout/index.html" target="_blank">都市晨报</a>
            <a href="https://szb.cnxz.com.cn/pcwb/pc/layout/index.html" target="_blank">彭城晚报</a>
            <a href="https://www.hanfenghao.com/" target="_blank">汉风号客户端</a>
            <a href="https://xzbycm.xzyunchuang.com/" target="_blank">集团官网</a>
          </p>
        </div>
      </div>
      <div>
        <div class="head_seach">
          <el-input class="input-with-select" placeholder="输入关键词" v-model="selectInps">
            <el-button slot="append" icon="el-icon-search" @click="goSeach()"></el-button>
          </el-input>
        </div>
      </div>

    </div>
    <div class="head_icon">
      <span :class="{ 'item_check': (tabIndex == index) }" v-for="(item, index) in tabData" :key="index"
        @click="goRouter(item, index)">
        {{ item.name }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contactUs',
  props: {
    tabIndex: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      tabData: [
        { name: '首页', id: null, linkUrl: '/', route: '' },
        { name: '时政要闻', id: '11', linkUrl: '', route: '' },
        { name: '徐州新闻', id: '1', linkUrl: '', route: '' },
        { name: '县域新闻', id: '19', linkUrl: '/countyLevel', route: '' },
        { name: '徐州发布', id: null, linkUrl: 'https://www.xuzhoufabu.com', route: '' },
        { name: '徐州网视', id: '1833803344738340864', linkUrl: '', route: '', link: 'https://video.cnxz.com.cn/' },
        { name: '彭城e评', id: '6', linkUrl: '', route: '' },
        { name: '网罗天下', id: '10', linkUrl: '', route: '' },
        { name: '安全生产', id: '47', linkUrl: '', route: '' },
        { name: '法律援助', id: '61', linkUrl: '', route: '' },
        { name: '健康生活', id: '3', linkUrl: '', route: '' },
        { name: '热点专题', id: null, linkUrl: '/topic', route: '' }
      ],
      systemTime: '',
      week: '',
      selectInps: '',
    }
  },
  mounted() {
    this.addDate();
  },
  methods: {
    goSeach() {
      window.open('/seach?name=' + this.selectInps, "_blank");
    },
    goRouter(item, index) {
      if (item.linkUrl) {
        if (index) {
          window.open(item.linkUrl + '?tab=' + index, "_blank");
        } else {
          window.open(item.linkUrl, "_blank");
        }

      } else {
        window.open('/importNews?id=' + item.id + '&tab=' + index, "_self");
      }
    },
    // 当前时间
    addDate() {
      let nowDate = new Date()
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      console.log(nowDate.getDay())
      this.systemTime = date.year + '年' + date.month + '月' + date.date + '日';

      var digits = ['日', '一', '二', '三', '四', '五', '六'];
      this.week = digits[nowDate.getDay()];
      console.log(this.systemTime)
    }
  }
}
</script>
<style scoped lang="scss">
.head_info {
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin: 20px 0;
  border-bottom: 4px solid #E00001;

  .head_info_logo {
    img {
      width: 200px;
    }

    padding-bottom: 10px;

    div {
      display: inline-block;
      margin-left: 20px;
      color: #686B6C;
      font-size: 14px;
      line-height: 24px;

      p {
        &:last-child {
          margin-top: 5px;
        }

        span {
          margin-left: 10px;
        }
      }

      a {
        margin-right: 20px;
        margin-top: 5px;
        color: #E00001;
        font-size: 15.5px;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          border-bottom: 1px solid #E00001;
        }
      }

      a:hover {
        text-decoration: dashed;
      }
    }
  }

  .head_seach {
    background: url('https://hfy-img.xzyunchuang.com/a911137c10e6cf276d7f1d9aeaa8d2fb');
  }

}

/deep/ .input-with-select {
  margin: 5px 12px 5px 60px;
  position: relative;
  top: 3px;
  height: 25px;
  line-height: 25px;
  font-size: 13px;
  width: 250px;

  .el-input__inner {
    height: 27px;
    line-height: 27px;
    border-right: none;
  }

  .el-input-group__append {
    height: 25px;
    line-height: 25px;
    background: #fff;
    padding: 0 10px;
    border-color: #fff;
  }
}

.head_icon {
  background: #F0F0F0;
  line-height: 47px;
  padding: 0 20px;
  display: flex;
  color: #686B6C;
  font-size: 17px;
  justify-content: space-between;

  .item_check {
    color: #E00001;
  }

  span {
    cursor: pointer;

    &:hover {
      position: relative;

      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: #686B6C;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/indexTab.vue